(function () {
  var SEL = '.page-width.section-template--24815946924377__custom_featured_collection_mPYpTA-padding';

  function init() {
    var wrap = document.querySelector(SEL);
    if (!wrap || wrap.querySelector('.cfc-bg-link')) return;

    var src = wrap.querySelector('.custom-featured-collection-header a[href]');
    if (!src) { console.log('no src'); return;   } // geen link in de header, dan geen overlay

    if (getComputedStyle(wrap).position === 'static') {
      wrap.style.position = 'relative';
    }

    var pt = parseFloat(getComputedStyle(wrap).paddingTop) || 220;

    var a = document.createElement('a');
    a.href = src.getAttribute('href');
    a.className = 'cfc-bg-link';
    a.setAttribute('aria-hidden', 'true');
    a.setAttribute('tabindex', '-1');

    a.style.cssText =
      'position:absolute;' +
      'top:0;' +
      'left:50%;' +
      'transform:translateX(-50%);' +
      'width:100vw;' +
      'height:' + pt + 'px;' +
      'z-index:5;' +
      'display:block;';

    wrap.prepend(a);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
